<template>
 <div >
   <el-empty description="敬请期待"></el-empty>
   <div style="color: #909399;text-align: center;font-size: 14px">如需紧急联系,请跳转至
     <el-link type="info" @click="goFeedback" style="margin-bottom: 3px">问题反馈</el-link>
     或发送邮件至 info@doyle.wang
   </div>
 </div>
</template>

<script>

export default {
  name: 'Message',
  methods: {
    goFeedback () {
      if (this.$route.path === '/about/feedback') {
        return
      }
      this.$router.push('/about/feedback')
    }
  },
  created () {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/message/Message.vue